import { t } from '@lingui/macro';
import React from 'react';
import PropTypes from 'prop-types';

import { setStorage, StorageTypes } from '@helpers/storage';

const ExpandSidebarButton = ({ collapsed, setCollapsed }) => {
  const handleToggle = () => {
    setCollapsed((prevState) => {
      setStorage(StorageTypes.Local, 'assetModalAttachmentsSidebarCollapsed', !prevState);
      BF.fx.dispatchWindowEvent('updateSidebarCollapsed', null, { isCollapsed: !prevState });
      return !prevState;
    });
  };

  const expandSidebarLabel = collapsed
    ? t`Back, expand attachments sidebar`
    : t`Collapse attachments sidebar`;

  return (
    <button
      aria-expanded={!collapsed}
      aria-label={expandSidebarLabel}
      className="expand-sidebar-button"
      onClick={handleToggle}
      type="button"
    >
      <span aria-hidden="true" className="bff-arrow-right" />
      <span aria-hidden="true" className="bff-arrow-left" />
    </button>
  );
};

ExpandSidebarButton.propTypes = {
  collapsed: PropTypes.bool,
  setCollapsed: PropTypes.func.isRequired,
};

ExpandSidebarButton.defaultProps = {
  collapsed: false,
};

export default ExpandSidebarButton;
